<template>
<v-card flat class="mx-5">
    <v-card-text class = "py-5 px-5" style="margin-top:40px">
        <v-text-field
            hide-details
            label="Идентификатор документа"
            auto-grow
            outlined
            rows="1"
            row-height="15"
            v-model="docid"
        ></v-text-field>
        <v-btn block color="success" class="mt-5" @click="check">
            Проверить 
        </v-btn>
    </v-card-text>
</v-card>
</template>

<script>

export default {
  data () {
    return {
      docid: ''
    }
  },
  computed: {
  },
  methods: {
    check() {
      this.$store.dispatch('setDocid', this.docid)
      // this.$store.dispatch('setFromPage', '/idchek')
      this.$router.push('/results')
    }
  }
}
</script>
